import { memo, useRef, useEffect, useCallback } from 'react';
import { isSameDay, isSameMonth, isToday as dateFnsIsToday } from 'date-fns';
import { useCalendar } from '../../Context';
import { DayContainer, DayButton } from '../../styled';
import { isDateDisabled } from '../../utils';
const Day = memo((props) => {
    const { date } = props;
    const { value, onChange, focusedDate, setFocusedDate, timeZone, locale, min, max } = useCalendar();
    const isToday = dateFnsIsToday(date);
    const isSelected = isSameDay(value, date);
    const shouldFocus = isSameDay(date, focusedDate);
    const elementRef = useRef(null);
    const disabled = isDateDisabled({ date, min, max });
    const title = new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        timeZone,
    }).format(date);
    useEffect(() => {
        if (elementRef.current && shouldFocus) {
            elementRef.current.focus();
        }
    }, [elementRef, shouldFocus]);
    const ariaFormat = new window.Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone,
    });
    const handleClick = useCallback(() => {
        if (onChange) {
            onChange(date);
        }
    }, [onChange, date]);
    const handleFocus = useCallback(() => {
        setFocusedDate(date);
    }, [setFocusedDate, date]);
    return (<DayContainer>
      <DayButton $isSelected={isSelected} onClick={handleClick} onFocus={handleFocus} disabled={disabled} ref={elementRef} tabIndex={isSameDay(value, date) ? 0 : -1} $isSameMonth={isSameMonth(date, focusedDate)} aria-label={ariaFormat.format(date)} $isToday={isToday}>
        {title}
      </DayButton>
    </DayContainer>);
});
Day.displayName = 'Day';
export default Day;
